import type { ServerConnection } from "@/context/server"

type RemoteServer = {
  url: string
  displayName?: string
  username?: string
}

type RemoteResponse = { servers?: RemoteServer[] }

export function createCastaliaServerStore(input: { apiUrl: string; token: string }) {
  let pending: Promise<void> = Promise.resolve()
  const request = (init?: RequestInit) =>
    fetch(`${input.apiUrl.replace(/\/+$/, "")}/codespace/servers`, {
      ...init,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${input.token}`,
        ...(init?.headers ?? {}),
      },
    })

  return {
    async load() {
      const response = await request()
      if (!response.ok) throw new Error(`Castalia server list failed (${response.status})`)
      const body = (await response.json()) as RemoteResponse
      return (body.servers ?? []).map((server): ServerConnection.Http => ({
        type: "http",
        displayName: server.displayName,
        http: { url: server.url, username: server.username },
      }))
    },
    save(servers: ServerConnection.Http[]) {
      const next = pending.then(async () => {
        const response = await request({
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            servers: servers.map((server) => ({
              url: server.http.url,
              ...(server.displayName ? { displayName: server.displayName } : {}),
              ...(server.http.username ? { username: server.http.username } : {}),
            })),
          }),
        })
        if (!response.ok) throw new Error(`Castalia server list save failed (${response.status})`)
      })
      pending = next.catch(() => {})
      return next
    },
  }
}
